module.exports = __webpack_public_path__ + "fonts/Cabin-Regular.2cfad1d.ttf";